import { Fragment, memo } from 'react';
import { AppSelectBox, AppTextField } from 'components';

function SetTime({ handleTime, time, timeLabel }) {
  return (
    <Fragment>
      <div className="row mb-4">
        <div className="col-12 d-flex">
          <section style={{ width: '10%' }}>
            <AppTextField
              labelProps={{
                label: 'Read time',
              }}
              inputProps={{
                min: 0,
                type: 'number',
                placeholder: 'Time',
                value: time,
                onChange: (event) => {
                  handleTime({ time: event.target.valueAsNumber });
                },
              }}
            />
          </section>
          <section style={{ width: '10%' }} className="mx-2">
            <AppSelectBox
              labelProps={{ label: 'Format' }}
              selectProps={{
                value: timeLabel,
                onChange: (event) => handleTime({ timeLabel: event.target.value }),
              }}
            >
              <option value="Min">Min</option>
              <option value="Hrs">Hrs</option>
            </AppSelectBox>
          </section>
        </div>
      </div>
    </Fragment>
  );
}

SetTime.defaultProps = {
  handleTime: () => {},
  time: 0,
  timeLabel: 'Min',
};

export default memo(SetTime);
